import { Controller } from "@/controllers/Controller";

/**
 * Controller for the payment declaration API ("Encaissée" statuses sent to the platform)
 */
export class PaymentTransmissionController extends Controller {

    /**
     * Paiements d'une facture (ou d'un acompte) transmise, avec l'état de leur déclaration : ne transmet rien
     * @param associationId id de l'association de transmission du document
     */
    static getPayments(associationId) {
        return this.requestBuilder("GET", `/ms-transmission/payment-transmission/association/${associationId}`, true);
    }

    /**
     * Transmet les paiements à la plateforme et renvoie leur état à jour
     * @param associationId id de l'association de transmission du document
     * @param collectionId un seul paiement (tous ceux à transmettre si absent)
     * @param force transmettre un paiement qui n'avait pas à être déclaré (avec collectionId uniquement)
     */
    static declare(associationId, collectionId = undefined, force = false) {
        return this.requestBuilder("POST", `/ms-transmission/payment-transmission/association/${associationId}/declare${this.buildParams({collectionId, force: force ? "true" : undefined})}`, true);
    }

}
